/* Tonoko — Colección. Filtra y ordena las tarjetas ya renderizadas (server-side)
   sin re-pintar: muestra/oculta y reordena nodos del DOM. Vanilla, defensivo. */
(function () {
  'use strict';
  var root = document.querySelector('[data-tnk-collection]');
  if (!root) return;

  var grid = root.querySelector('[data-tnk-grid]');
  var form = root.querySelector('[data-tnk-filterform]');
  var sortSel = root.querySelector('[data-tnk-sort]');
  var countEl = root.querySelector('[data-tnk-count]');
  var emptyEl = root.querySelector('[data-tnk-empty]');
  if (!grid || !form) return;

  var GROUPS = ['brand', 'type', 'line', 'color'];
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.pcard'));
  var originalOrder = cards.slice();

  function val(card, g) {
    return (card.getAttribute('data-' + g) || '').trim();
  }
  function title(card) {
    var t = card.querySelector('.pcard__title');
    return t ? t.textContent.trim() : '';
  }

  /* ----- poblar filtros desde los valores presentes ----- */
  function buildFilters() {
    GROUPS.forEach(function (g) {
      var values = {};
      cards.forEach(function (c) {
        var v = val(c, g);
        if (v) values[v] = true;
      });
      var list = Object.keys(values).sort(function (a, b) {
        return a.localeCompare(b, 'es');
      });
      var box = form.querySelector('[data-opts="' + g + '"]');
      var fieldset = form.querySelector('[data-filter-group="' + g + '"]');
      if (!box || !fieldset) return;
      if (!list.length) {
        fieldset.hidden = true;
        return;
      }
      fieldset.hidden = false;
      list.forEach(function (v) {
        var label = document.createElement('label');
        label.className = 'opt';
        var input = document.createElement('input');
        input.type = 'checkbox';
        input.value = v;
        input.setAttribute('data-group', g);
        var span = document.createElement('span');
        span.textContent = v;
        label.appendChild(input);
        label.appendChild(span);
        box.appendChild(label);
      });
    });
  }

  function activeVals(g) {
    return Array.prototype.slice.call(form.querySelectorAll('input[data-group="' + g + '"]:checked')).map(function (i) {
      return i.value;
    });
  }

  function sortCards() {
    var mode = sortSel ? sortSel.value : 'best';
    var arr;
    if (mode === 'yield') {
      arr = cards.slice().sort(function (a, b) {
        return (parseInt(b.getAttribute('data-yield'), 10) || 0) - (parseInt(a.getAttribute('data-yield'), 10) || 0);
      });
    } else if (mode === 'az') {
      arr = cards.slice().sort(function (a, b) {
        return title(a).localeCompare(title(b), 'es');
      });
    } else {
      arr = originalOrder.slice();
    }
    arr.forEach(function (c) {
      grid.appendChild(c);
    });
    if (emptyEl) grid.appendChild(emptyEl); // mantener el aviso al final
  }

  function apply() {
    var actives = {};
    GROUPS.forEach(function (g) {
      actives[g] = activeVals(g);
    });
    var visible = 0;
    cards.forEach(function (card) {
      var show = GROUPS.every(function (g) {
        var sel = actives[g];
        if (!sel.length) return true;
        return sel.indexOf(val(card, g)) !== -1;
      });
      card.hidden = !show;
      if (show) visible++;
    });
    if (emptyEl) emptyEl.hidden = visible !== 0;
    if (countEl) countEl.textContent = visible + (visible === 1 ? ' producto' : ' productos');
    sortCards();
  }

  /* ----- init ----- */
  if (!cards.length) {
    if (countEl) countEl.textContent = '0 productos';
    return;
  }
  buildFilters();
  form.addEventListener('change', apply);
  if (sortSel) sortSel.addEventListener('change', apply);
  Array.prototype.slice.call(root.querySelectorAll('[data-tnk-clear]')).forEach(function (btn) {
    btn.addEventListener('click', function () {
      form.reset();
      apply();
    });
  });

  var toggle = root.querySelector('[data-tnk-filtertoggle]');
  var filters = root.querySelector('[data-tnk-filters]');
  if (toggle && filters) {
    toggle.addEventListener('click', function () {
      var open = filters.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  apply();
})();
